import { render, staticRenderFns } from "./reviewAddonsComponent.vue?vue&type=template&id=7e5c8fc7"
import script from "./reviewAddonsComponent.vue?vue&type=script&lang=js"
export * from "./reviewAddonsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports